import { Grid } from '@packages/shared';
import { browserCanShare } from '../../../helpers/browserCanShare';
import type { ShareButtonProps } from '../../ShareButton';
import { ShareButton } from '../../ShareButton';

/*
 * The ShareButtonGridItemCore is main component.
 * However, it triggers a hydration error because the button cannot be rendered on the server, as window.navigator.share is not present there.
 * On the client, the button can be displayed based on browser support, leading to the hydration error when the button is shown.
 * The solution of displaying the button only after mounting is an antipattern, which is accepted here.
 * The alternative of lazy loading the ShareButton is not worthwhile, as it would require an additional chunk and an extra fetch,
 * which is deemed too excessive for the small code of this component.
 */

export const ShareButtonGridItemCore = (props: ShareButtonProps) => {
  if (!browserCanShare()) {
    return null;
  }

  return (
    /**
     * INFO: The grid is not included in ProductVariation.
     * This decision stems from the scenario where the button cannot be rendered due to the absence of window.navigator.share.
     * In this case, rendering an empty grid would result in unnecessary padding, which is to be avoided.
     */
    <Grid item xs={12}>
      <ShareButton {...props} />
    </Grid>
  );
};
